import {
  SOLUTION_TYPE,
  SolutionType,
} from '../../../shared/constants/user-info/solutionType';

type GetCustomerProfileUrlParams = {
  solutionType: SolutionType;
  entityId: number;
  customerId: number;
  withHashPrefix?: boolean;
};

export const getCustomerProfileUrl = ({
  solutionType,
  entityId,
  customerId,
  withHashPrefix = true,
}: GetCustomerProfileUrlParams) => {
  switch (solutionType) {
    case SOLUTION_TYPE.SCAN_IQ:
      return `${withHashPrefix ? '#!' : ''}/customer-profile/scan-iq/${entityId}/${customerId}`;
    case SOLUTION_TYPE.CHALLENGE:
      return `${withHashPrefix ? '#!' : ''}/challenge-profile/${entityId}/${customerId}`;
    case SOLUTION_TYPE.NUTRITION:
      return `${withHashPrefix ? '#!' : ''}/customer-profile/${customerId}`;
    default:
      return '';
  }
};
